import type { CustomComponent } from '../../config/types.js'

export type CustomPreviewButton = CustomComponent
